module.exports = __webpack_public_path__ + "img/tian-ling.cbe1afac.jpeg";